export const sectorConstants = {
  ADD_REQUEST: 'SECTORS_ADD_REQUEST',
  ADD_SUCCESS: 'SECTORS_ADD_SUCCESS',
  ADD_FAILURE: 'SECTORS_ADD_FAILURE',
  
  GETALL_REQUEST: 'SECTORS_GETALL_REQUEST',
  GETALL_SUCCESS: 'SECTORS_GETALL_SUCCESS',
  GETALL_FAILURE: 'SECTORS_GETALL_FAILURE',

  DELETE_REQUEST: 'SECTORS_DELETE_REQUEST',
  DELETE_SUCCESS: 'SECTORS_DELETE_SUCCESS',
  DELETE_FAILURE: 'SECTORS_DELETE_FAILURE',

  GETBYID_REQUEST: 'SECTORS_GETBYID_REQUEST',
  GETBYID_SUCCESS: 'SECTORS_GETBYID_SUCCESS',
  GETBYID_FAILURE: 'SECTORS_GETBYID_FAILURE',

  UPDATE_REQUEST: 'SECTORS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'SECTORS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'SECTORS_UPDATE_FAILURE',

  GETALL_PAGE_REQUEST: 'SECTORS_GETALL_PAGE_REQUEST',
  GETALL_PAGE_SUCCESS: 'SECTORS_GETALL_PAGE_SUCCESS',
  GETALL_PAGE_FAILURE: 'SECTORS_GETALL_PAGE_FAILURE',

  UPDATE_FILTER_REQUEST: 'UPDATE_SECTOR_FILTER_REQUEST',
  UPDATE_FILTER_SUCCESS: 'UPDATE_SECTOR_FILTER_SUCCESS',
  UPDATE_FILTER_FAILURE: 'UPDATE_SECTOR_FILTER_FAILURE',

  GET_CHART_DATA_REQUEST: 'SECTORS_GET_CHART_DATA_REQUEST',
  GET_CHART_DATA_SUCCESS: 'SECTORS_GET_CHART_DATA_SUCCESS',
  GET_CHART_DATA_FAILURE: 'SECTORS_GET_CHART_DATA_FAILURE',

  GET_SI_CHART_DATA_REQUEST: 'SECTORS_GET_SI_CHART_DATA_REQUEST',
  GET_SI_CHART_DATA_SUCCESS: 'SECTORS_GET_SI_CHART_DATA_SUCCESS',
  GET_SI_CHART_DATA_FAILURE: 'SECTORS_GET_SI_CHART_DATA_FAILURE',

  LINK_CHART_REQUEST: 'SECTORS_LINK_CHART_REQUEST',
  LINK_COMPANY_REQUEST: 'SECTORS_LINK_COMPANY_REQUEST',
  LINK_COMPANY_SUCCESS: 'SECTORS_LINK_COMPANY_SUCCESS',
  LINK_COMPANY_FAILURE: 'SECTORS_LINK_COMPANY_FAILURE',
  LINK_CHART_FAILURE: 'SECTORS_LINK_CHART_FAILURE',
}
